import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './FloatingPanel.scss';

class FloatingPanel extends Component {

    render() {
        const { count, text, } = this.props;
        return <div className='floating-panel' id='floating-panel' style={{
            display: 'none'
        }}>
            <div className='floating-count'>
                <div className='round-number'>{count}</div>
            </div>
            <div className='floating-text'>
                <div id='floating-panel-text' className='aligned-text'>{text}</div>
            </div>
        </div>
    }
}

FloatingPanel.propTypes = {
    count: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    pageXCord: PropTypes.number,
    pageYCord: PropTypes.number,
};

FloatingPanel.defaultProps = {
};


export default (FloatingPanel);
